
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppService } from '../service/AppService.class';
import { Observable } from 'rxjs';



@Injectable()
export class MortgageService extends AppService<any>{
  constructor(protected http:HttpClient) {
    super(http);
    this.appmod="";
  }

  public getdialertitle(): Observable<any> {
    return this.http.get('/assets/dialer/dialer1.json')
  }

  insuranceData(sdata):Observable<any>
  {
    console.log(sdata);

    let tmp = this.appmod;
    this.appmod = 'custom/insuranceSearch';
    let result = this.saveService(sdata);
    this.appmod = tmp;
    return result;
  }

  leadUpdate(ldata:any, key:number):Observable<any>
  {
    console.log("ldata & key",ldata,key);
    let tmp = this.appmod;
    this.appmod="custom/leadupdate";
    let leaddata = this.updateService(ldata, key);
    this.appmod=tmp;
    return leaddata;
  }
  //search insurance get data
  public searchInsuranceVm():Observable<any>{
    let tmp = this.appmod;
    this.appmod="custom/searchInsurance";   
    let leaddata = this.getService();
    this.appmod=tmp;
    return leaddata;
  }
  //health category
  public healthcatagory():Observable<any>{
    console.log("new data in category")
    let tmp = this.appmod;
    this.appmod="custom/healthCategories";   
    let leaddata = this.getService();
    this.appmod=tmp;
    return leaddata;
  }
  //health sub category
  public healthsubcatagory(sdata):Observable<any>{
    console.log(sdata);
    let tmp = this.appmod;
    this.appmod = 'custom/healthsubCategories';
    let result = this.saveService(sdata);
    this.appmod = tmp;
    return result;
  }
  
    //search insurance in Api
    public SearchAPI(sdata):Observable<any>{
      console.log(sdata);
      let tmp = this.appmod;
      this.appmod = 'custom/searchInsuranceApi';
      let result = this.saveService(sdata);
      this.appmod = tmp;
      return result;
    }

      //search insurance in Api
      public WeightAPI(sdata):Observable<any>{
        console.log(sdata);
        let tmp = this.appmod;
        this.appmod = 'custom/weightApi';
        let result = this.saveService(sdata);
        this.appmod = tmp;
        return result;
      }
       //search insurance  savebuildchart in Api
       public savebuildchart(sdata):Observable<any>{
        console.log(sdata);
        let tmp = this.appmod;
        this.appmod = 'custom/buildchatApi';
        let result = this.saveService(sdata);
        this.appmod = tmp;
        return result;
      }
}





